
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {
sendMobileCode,
validMobileCode,
alipayValidMobileCode,
alipaySendMobileCode,
getProfile
} from "../common/js/api.js";
import { getCookie, setCookie, removeCookie } from "../common/js/utils";
import router from "@/router/index.js";

export default {
directives: {
TransferDom
},
components: {
Box,
XButton,
XInput,
Group,
TransferDom
},
methods: {
djs() {
let self = this;
if (self.lessTime > 0) {
self.lessTime--;
} else {
self.view.disabled = false;
self.view.codeText = "获取验证码";
return;
}
self.view.disabled = true;
self.view.codeText = "" + self.lessTime + "s后重发";
setTimeout(self.djs, 1000);
},
isAliOrWx() {

let typeBower = '';
let browser = {
versions: function() {
let u = navigator.userAgent,
app = navigator.appVersion;
return { //移动终端浏览器版本信息
trident: u.indexOf('Trident') > -1, //IE内核
presto: u.indexOf('Presto') > -1, //opera内核
webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
iPad: u.indexOf('iPad') > -1, //是否iPad
webApp: u.indexOf('Safari') == -1 
};
}(),
language: (navigator.browserLanguage || navigator.language).toLowerCase()
};
if(browser.versions.mobile) { //判断是否是移动设备打开。browser代码在下面

var ua = navigator.userAgent.toLowerCase(); 
if(ua.match(/Alipay/i)=="alipay"){
typeBower = 'ali';
}
if(ua.match(/MicroMessenger/i) == "micromessenger") {
typeBower = 'wx';
}
}
return typeBower;
},

sendMobileCode() {
let self = this;
if (!this.entity.realName) {
self.$vux.toast.text("请输入姓名");
return;
}
if (!this.entity.mobile) {
self.$vux.toast.text("请输入手机号");
return;
}
var pattern = /^1[2|3|4|5|6|7|8|9]\d{9}$/;
if (!pattern.test(this.entity.mobile)) {
self.$vux.toast.text("手机号不正确");
return;
}

if( this.isAliOrWx() == 'ali'){
alipaySendMobileCode({ data: { mobile: this.entity.mobile } }).then(function(
data
) {
self.$vux.toast.text("验证码已发送");
self.lessTime = 60;
setTimeout(self.djs, 1000);
self.sendCode = true;
});

}else{
sendMobileCode({ data: { mobile: this.entity.mobile } }).then(function(
data
) {
self.$vux.toast.text("验证码已发送");
self.lessTime = 60;
setTimeout(self.djs, 1000);
self.sendCode = true;
});
}

},

zfbcheckJump(backurl){

if ( /AlipayClient/.test(window.navigator.userAgent)  && backurl.indexOf('/#/yue') > -1 ) {
removeCookie("redirect");
removeCookie("yueBirdredirect");
removeCookie("yueredirect");
window.location = window.location.origin+"/#/yueIndex";
}
},

sendMsg(){
const self = this
var user = JSON.parse( getCookie("user") );
self.$vux.loading.show({text: ''});
if( this.isAliOrWx() == 'ali' && ( !user.userId || user.userId=='' )){
var dataObj = {
mobile: this.entity.mobile,
openId: user.openId,
code: this.entity.code,
realName: this.entity.realName
};
alipayValidMobileCode({
data: dataObj
}).then(function(data) {
self.$vux.loading.hide();
let backData = data.Content;

let user = getCookie("user");
if (user) {
user = JSON.parse(user);
user.phoneCertification = 1;
}

if( backData.userId ){
user = backData;
}

if( user ){
setCookie("user", JSON.stringify(user));
}
let redirect = getCookie("redirect");
if (redirect) {
self.zfbcheckJump(redirect);

removeCookie("redirect");
if(redirect.indexOf('yueIndex') > -1) {
const jumpUrl = redirect.split('#')[1]
self.$router.replace({ path: jumpUrl })
} else {
window.location.href = redirect;
}

}
else {
let yueBirdredirect = getCookie("yueBirdredirect");
if( yueBirdredirect!=null && yueBirdredirect!='' ){
removeCookie("yueBirdredirect");
window.location.href = yueBirdredirect;
}else{
router.replace({ path: "/" });
}
}
});
}else{
validMobileCode({
data: {
mobile: this.entity.mobile,
code: this.entity.code,
realName: this.entity.realName
}
}).then(function(data) {
self.$vux.loading.hide();

let user = getCookie("user");
if (user) {
user = JSON.parse(user);
user.phoneCertification = 1;
setCookie("user", JSON.stringify(user));
}
let redirect = getCookie("redirect");
if (redirect) {
self.zfbcheckJump();
removeCookie("redirect");
if(redirect.indexOf('yueIndex') > -1) {
const jumpUrl = redirect.split('#')[1]
self.$router.replace({ path: jumpUrl })
} else {
window.location.href = redirect;
}
} else {
let yueBirdredirect = getCookie("yueBirdredirect");
if( yueBirdredirect!=null && yueBirdredirect!='' ){
removeCookie("yueBirdredirect");
window.location.href = yueBirdredirect;
}else{
router.replace({ path: "/" });
}
}
});
}

},

onSubmit(val) {
let self = this;
if (!this.entity.realName) {
self.$vux.toast.text("请输入姓名");
return;
}
if (!this.entity.mobile) {
self.$vux.toast.text("请输入手机号");
return;
}
var pattern = /^1[2|3|4|5|6|7|8|9]\d{9}$/;
if (!pattern.test(this.entity.mobile)) {
self.$vux.toast.text("手机号不正确");
return;
}
if (!self.sendCode) {
self.$vux.toast.text("您还未获取验证码");
return;
}
if (!this.entity.code) {
self.$vux.toast.text("请输入验证码");
return;
}
if (4 != this.entity.code.length) {
self.$vux.toast.text("验证码错误");
return;
}

self.sendMsg();
}
},
data() {
return {
lessTime: 0,
view: {
codeText: "获取验证码",
disabled: false,
sendCode: false
},
entity: {
mobile: "",
code: ""
},
cover: "",
isPartner: false
};
},
created() {
let self = this;
let redirect = getCookie("redirect");

if (redirect && redirect.indexOf("lottery") > -1) {

self.zfbcheckJump();

let yueBirdredirect = getCookie("yueBirdredirect");
if( yueBirdredirect!=null && yueBirdredirect!='' ){
removeCookie( "yueBirdredirect" );
window.location.href = yueBirdredirect;
return;
}
window.location.href = redirect;
return;
}
let partnerId = getCookie("invitePartnerId");
if (partnerId) {
this.isPartner = true;
this.cover = "../../static/images/partner_auth.jpg";
} else {
this.cover = "../../static/images/logo3.png";
}













}
};



// WEBPACK FOOTER //
// ./src/components/MobileAuth.vue